export const interiorA02ImageOptions = {
  angle: 'InteriorA02',
  staticOptions: {
    UpholsteryCabin: 1
  },
  mattes: [
    {
      option: 'UpholsteryCabin',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xpower/views/InteriorA02.js